import { BasicTable } from '@/lib/components/tables/BasicTable';
import { useGetWatercoachRegistraties } from '@/lib/queries/config-api/watercoach';
import { BasicTableColumn } from '@/lib/types';
import { WatercoachDeelnemerOverview } from '@/lib/types/watercoach';
import { Card } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

export const WatercoachPage: React.FunctionComponent = () => {
  const navigate = useNavigate();
  const { t } = useTranslation('core');

  const columns: BasicTableColumn<WatercoachDeelnemerOverview>[] = [
    { label: 'deelnemer.uONummer', dataIndex: 'uoNummer', sortable: true, filterable: true },
    { label: 'deelnemer.bedrijfsnaam', dataIndex: 'bedrijfsnaam', sortable: true, filterable: true },
    { label: 'deelnemer.vestigingsStraat', dataIndex: 'vestigingsStraat', sortable: true, filterable: true },
    { label: 'deelnemer.vestigingsNummer', dataIndex: 'vestigingsNummer', sortable: true, filterable: true },
    { label: 'deelnemer.vestigingsNummerToevoeging', dataIndex: 'vestigingsNummerToevoeging', sortable: true, filterable: true },
    { label: 'deelnemer.vestigingsPostcode', dataIndex: 'vestigingsPostcode', sortable: true, filterable: true },
    { label: 'deelnemer.vestigingsPlaats', dataIndex: 'vestigingsPlaats', sortable: true, filterable: true },
    {
      label: 'watercoach.overviewBenaderd',
      dataIndex: 'benaderd',
      sortable: true,
      filterable: true,
      render: value => {
        if (value == null) {
          return '-';
        }

        return value ? t('boolean.yes') : t('boolean.no');
      },
    },
    {
      label: 'watercoach.overviewBezoekDatum',
      dataIndex: 'bezoekDatum',
      sortable: true,
      filterable: true,
      render: value => (value ? new Date(value as string).toLocaleDateString() : '-'),
    },
    {
      label: 'watercoach.overviewAdviesDatum',
      dataIndex: 'adviesOpgevolgdDatum',
      sortable: true,
      filterable: true,
      render: value => (value ? new Date(value as string).toLocaleDateString() : '-'),
    },
  ];

  return (
    <Card title={t('watercoach.title')}>
      <BasicTable<WatercoachDeelnemerOverview> loadEntries={useGetWatercoachRegistraties} columns={columns} onEdit={id => navigate(id.toString())} />
    </Card>
  );
};
